export { default } from './ImageViewerCorner';
